import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';

import { SpecialProperties as SpecialProperty } from '@products/interfaces/models';
import { SubformBaseComponent } from '@shared/components/subform-base/subform-base.component';

@Component({
  selector: 'app-special-properties-subform',
  templateUrl: './special-properties-subform.component.html',
  styleUrls: ['./special-properties-subform.component.scss'],
})
export class SpecialPropertiesSubformComponent
  extends SubformBaseComponent
  implements OnInit
{
  @Input() readOnly = false;
  DICT_PATH = 'PRODUCTS';
  specialParameters = SpecialProperty.SpecialParameters;
  marketingLabels = SpecialProperty.MarketingLabelsEnum;
  experienceCategories = SpecialProperty.ExperienceCategoriesEnum;
  foodPairings = SpecialProperty.FoodPairingsEnum;

  static buildForm(fb: FormBuilder) {
    return fb.group({
      specialParameters: [null],
      specialParametersOther: [''],
      marketingLabels: [null],
      experienceCategories: [null],
      foodPairings: [null],
    });
  }
}
